import { render, staticRenderFns } from "./ComparadorFolioHeader.vue?vue&type=template&id=3932a2d6&scoped=true"
import script from "./ComparadorFolioHeader.vue?vue&type=script&lang=js"
export * from "./ComparadorFolioHeader.vue?vue&type=script&lang=js"
import style0 from "./ComparadorFolioHeader.vue?vue&type=style&index=0&id=3932a2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3932a2d6",
  null
  
)

export default component.exports